import React from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { useQuery } from '@apollo/react-hooks'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import { GET_PROJECT } from '../../queries/project'
import { selectScenario, loadScenarios } from '../../actions'

export default function ScenarioSelect() {
  const dispatch = useDispatch()
  const { selectedProjectId, scenarios, remoteStorage, selectedScenarioId } =
    useSelector(state => state)

  let loading, data, filteredScenarios

  const handleScenarioSelect = event => {
    const id = event.target.value
    dispatch(selectScenario(id))
  }

  if (remoteStorage.scenarios) {
    const result = useQuery(GET_PROJECT, {
      variables: { id: selectedProjectId },
      onCompleted: data => {
        if (data && data.project && data.project.scenarios) {
          dispatch(loadScenarios(data.project.scenarios))
        }
      },
    })
    loading = result.loading
    data = result.data

    if (loading || data === undefined) {
      return <div />
    }
  }

  filteredScenarios = scenarios.filter(s => s.project_id === selectedProjectId)

  if (!filteredScenarios.length) {
    return <div />
  }

  return (
    <FormControl variant="filled" size="small" margin="dense">
      <InputLabel id="selectscenario-label">Scenario Select</InputLabel>
      <Select
        id="selectscenario"
        value={selectedScenarioId || ''}
        onChange={handleScenarioSelect}
      >
        {filteredScenarios.map(scenario => {
          return (
            <MenuItem dense key={scenario.id} value={scenario.id}>
              {scenario.name}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}
